/* -----------------------------------------------------------------
   JAC'D UP CUSTOM - mockup disclaimer under the product gallery.

   Three of the four gallery images on every Engraved product are AI
   ghost-mannequin mockups, generated to show the COLOURWAY. The
   lettering in them is approximate - it is not a render of the actual
   digitised stitch file. Only the lifestyle photo, which is the home
   colourway, shows the real font. This note says so, plainly, at the
   point where someone is clicking between colours and comparing.

   It sits under the thumbnail strip rather than in the info column,
   because it is a caption for the images, not a step in the purchase
   flow - it should not interrupt Colour / Size / Sleeve / Add to cart.

   IT MUST GO INSIDE <media-gallery>, as its last child. The first
   version appended it as a SIBLING after the gallery and it rendered
   on top of the photo: media-gallery carries Craft's
   .product__column-sticky, and a sticky element keeps its original
   slot in normal flow while it is drawn further down the page. A
   sibling placed after it therefore sits at the gallery's STATIC
   position - which, once the gallery is stuck, is somewhere in the
   middle of the image. Inside, it travels with it.

   Inside the gallery is still outside the stitched copper frame - the
   frame lives on .product-media-container, which wraps the image
   alone (see jacdup-product.css).

   Injected rather than templated because the gallery is rendered
   inside Craft's main-product section, which has no block slot on the
   media side. Kept in one self-contained file - markup, copy and
   styles together - because the whole feature is this one paragraph.
   To change the wording, change TEXT below; there is no theme setting
   for it.

   Remove this file (and its <script> tag in jacdup-head.liquid) once
   the mockups are replaced by real photography of every colourway.
   ----------------------------------------------------------------- */
(function () {
  'use strict';

  var TEXT =
    '*AI mockups are representations of different colorways only and may ' +
    'not represent the true style of font. The home colorway font is what ' +
    'will be applied if a different color is chosen.';

  var CSS =
    '.jd-mockup-note{' +
      'display:block;' +
      'margin:2.4rem auto 0;' +
      'max-width:46rem;' +
      'text-align:center;' +
      'text-wrap:balance;' +
      'font-size:1.15rem;' +
      'line-height:1.65;' +
      'font-weight:300;' +
      'letter-spacing:.01em;' +
      'color:rgba(var(--color-foreground),.5);' +
    '}' +
    '@media screen and (max-width:749px){' +
      '.jd-mockup-note{margin-top:1.8rem;font-size:1.1rem}' +
    '}';

  function styles() {
    if (document.getElementById('jd-mockup-note-css')) return;
    var s = document.createElement('style');
    s.id = 'jd-mockup-note-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function place() {
    var gallery = document.querySelector('.product__media-wrapper media-gallery');
    if (!gallery) return;

    var note = document.getElementById('jd-mockup-note');
    if (note && note.isConnected && note.parentElement === gallery && !note.nextElementSibling) return;

    if (!note || !note.isConnected) {
      note = document.createElement('p');
      note.id = 'jd-mockup-note';
      note.className = 'jd-mockup-note';
      note.textContent = TEXT;
    }
    gallery.appendChild(note);
  }

  function start() {
    styles();
    place();
    /* Craft re-renders parts of the product block on variant change. */
    document.addEventListener('change', function () { setTimeout(place, 400); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
